/**
 * This panel is displayed when a project has no jobs in it.
 */
import React from 'react';

import {urlPrefixed} from '../../../config';
import DOC_URLS from '../../../util/doc_urls';
import * as Urls from '../../../util/urls';
import * as S from './ZeroJobs.styles';

export const ZeroJobs: React.FC<{}> = () => {
  return (
    <S.Panel>
      <S.OffsetUp>
        <S.Circle>
          <S.LightBulb />
        </S.Circle>
        <S.Heading>This project does not have jobs yet.</S.Heading>
        <S.Message>
          Jobs are reusable, configurable run templates that allow you and your
          team to quickly launch new runs, locally or using extra GPUs. The
          easiest way to create jobs in Weights & Biases is to create and
          execute runs in your command line application. We'll automatically
          extract jobs and display them here.
        </S.Message>
        <S.Message>
          To view example jobs, from training a fashion MNIST model, to
          evaluating OpenAI LLMs, or deploying to Triton, navigate to the
          <S.Link
            href={urlPrefixed(
              Urls.jobs({entityName: 'wandb', projectName: 'jobs'})
            )}>
            wandb/jobs project
          </S.Link>
          . To create your own, check out the
          <S.Link href={DOC_URLS.launchJobs}>docs</S.Link>.
        </S.Message>
      </S.OffsetUp>
    </S.Panel>
  );
};
